import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import SimpleTableProps from "@/app/interfaces/props/SimpleTableProps";

const SimpleTable = ({
  headers,
  rows,
  align,
  size = "small",
  emptyText = "No data.",
}: SimpleTableProps) => {
  return (
    <TableContainer
      sx={{
        overflowX: "auto",
        whiteSpace: "nowrap",
      }}
    >
      <Table size={size} sx={{ tableLayout: "auto", minWidth: "100%" }}>
        <TableHead>
          <TableRow>
            {headers.map((header, index) => (
              <TableCell
                key={`h-${index}`}
                sx={{ fontWeight: 600, whiteSpace: "nowrap" }}
                align={align?.[index] ?? "left"}
              >
                {header}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.length === 0 ? (
            <TableRow>
              <TableCell colSpan={headers.length} align="center" sx={{ py: 3 }}>
                {emptyText}
              </TableCell>
            </TableRow>
          ) : (
            rows.map((row, rowIndex) => (
              <TableRow key={`r-${rowIndex}`}>
                {row.map((cell, cellIndex) => (
                  <TableCell
                    key={`c-${rowIndex}-${cellIndex}`}
                    align={align?.[cellIndex] ?? "left"}
                    sx={{
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                    }}
                  >
                    {cell}
                  </TableCell>
                ))}
              </TableRow>
            ))
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default SimpleTable;
